import type { MetaFunction } from '@remix-run/node';

import { getCanonicalURL } from '~/utils/getCanonicalURL';

import type { loader } from './loader';

export const meta: MetaFunction<
	never,
	{ [routeId: string]: typeof loader }
> = ({ location, matches }) => {
	const data = matches.find(match => /card$/.test(match.id))?.data;
	const metaTitle = data?.metaData.metaTitle;
	const metaDescription = data?.metaData.metaDescription;

	return [
		{ title: metaTitle },
		{ name: 'description', content: metaDescription },
		...(data?.componentStyles || []).map((href, index) => ({
			key: `componentStyles-${index}`,
			tagName: 'link',
			rel: 'stylesheet',
			href,
		})),
		{
			tagName: 'link',
			rel: 'canonical',
			href: getCanonicalURL(data?.url.toString(), location.pathname),
		},
	];
};
